function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import flatten from 'lodash/flatten';

var isPresentInOtherGroups = function isPresentInOtherGroups(propName, currentGroups) {
  return Object.values(currentGroups).some(function (group) {
    return group.list && group.list.indexOf(propName) > -1;
  });
};

var getGroupList = function getGroupList(styleProps, propGroup, currentGroups) {
  return styleProps.propNames.filter(function (propName) {
    // make list based on propGroup.pattern or name
    var pattern = propGroup.pattern || propGroup.name;

    if (propName === pattern) {
      return true;
    }

    var regex = new RegExp(pattern);

    if (regex.test(propName)) {
      // if already present in a group.list, don't add
      var isPresent = isPresentInOtherGroups(propName, currentGroups);

      if (!isPresent) {
        return true;
      }
    }

    return false;
  });
};

var getOthers = function getOthers(groups, propNames) {
  var collatedList = flatten(Object.values(groups).map(function (group) {
    return group.list;
  }));
  return propNames.filter(function (name) {
    return collatedList.indexOf(name) === -1;
  });
};

var getGroups = function getGroups(styleProps) {
  var groups = {};
  Object.values(styleProps.propGroups).forEach(function (propGroup) {
    var group = _objectSpread(_objectSpread({}, propGroup), {}, {
      list: []
    });

    group.list = getGroupList(styleProps, propGroup, groups);
    groups = _objectSpread(_objectSpread({}, groups), {}, _defineProperty({}, propGroup.name, group));
  }); // get others across groups, after we have the final lists

  var othersList = getOthers(groups, styleProps.propNames);
  var others = othersList.length > 0 ? {
    name: 'others',
    list: othersList
  } : null;

  if (others) {
    groups = _objectSpread(_objectSpread({}, groups), {}, {
      others: others
    });
  }

  return groups;
};

var addGroupData = function addGroupData(NeoSystem) {
  Object.keys(NeoSystem).forEach(function (key) {
    var system = NeoSystem[key];
    var groupedSystem = getGroups(system);
    system.propGroups = groupedSystem;
  });
  return NeoSystem;
};

export { addGroupData };